import { Button } from '@iwoca/orion';
import { deriveProductFromTypeAndDuration } from 'applicationTable/applicationUtils';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useAmplitude } from 'hooks/useAmplitude';
import { useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { getUnlockURL } from '../Products.helpers';
import styles from './UnlockFlexiLoanButton.module.css';

export const UnlockFlexiLoanButton = () => {
  const { introducerType, availableProducts, checkIntroducerPermission } =
    useIntroducerContext();
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();

  if (!introducerType) {
    return null;
  }

  const applyForProduct = () => {
    trackEvent(AMPLITUDE_EVENTS.signupCTAClicked, {
      'CTA location': 'Products',
      'CTA text': `Apply for a ${
        deriveProductFromTypeAndDuration({
          productType: 'credit_facility',
          isUK: true,
        }).name
      }`,
      'CTA URL': PATH_NAMES.newApplicationStep0(),
    });

    return navigate(PATH_NAMES.newApplicationStep0());
  };

  return (
    <div className={styles.unlockFlexiLoanButton}>
      {availableProducts?.includes('credit_facility') ? (
        <Button
          variant="success"
          disabled={!checkIntroducerPermission('can_create_applications')}
          onClick={() => applyForProduct()}
        >
          Apply now
        </Button>
      ) : (
        <Button
          variant="success"
          href={getUnlockURL('credit_facility', introducerType)}
          target="_blank"
          rel="noreferrer"
        >
          Get access to Flexi-Loan
        </Button>
      )}
    </div>
  );
};
